export enum CrusadeBattleSizes {
   CombatPatrol = 0,
   Incursion = 1,
   StrikeForce = 2,
   Onslaught = 2,
}
